import { render } from "./mark_session_final.vue?vue&type=template&id=1a061806"
import script from "./mark_session_final.vue?vue&type=script&lang=js"
export * from "./mark_session_final.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/staging2/web_head/releases/20251210221730/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__